// @flow
import * as React from 'react';
import FieldWrapper from 'platform/settings/form/renderers/layouts/FieldWrapper';
import SwitchControl, { switchControlTester } from './SwitchControl';
import EnumControl, { enumControlTester } from './EnumControl';
import TextFieldControl, { textFieldControlTester } from './TextFieldControl';
import ArrayTextFieldControl, {
    arrayTextFieldControlTester
} from './ArrayTextFieldControl';
import NumberFieldControl, {
    numberFieldControlTester
} from './NumberFieldControl';

import LanguageControl, { languageControlTester } from './LanguageControl';
import TimezoneControl, { timezoneControlTester } from './TimezoneControl';
import CountryCodeControl, {
    countryCodeControlTester
} from './CountryCodeControl';
import CountryDialCodeControl, {
    countryDialCodeControlTester
} from './CountryDialCodeControl';
import CurrencyControl, { currencyControlTester } from './CurrencyControl';
import NumberFormatControl, {
    numberFormatControlTester
} from './NumberFormatControl';
import ImageUploadControl, {
    imageUploadControlTester
} from './ImageUploadControl';
import TimeFieldControl, { timeFieldControlTester } from './TimeFieldControl';
import ArrayStringInputControl, {
    arrayStringInputControlTester
} from './ArrayStringInputControl';
import ArrayObjectInputControl, {
    arrayObjectInputControlTester
} from './ArrayObjectInputControl';
import CallbackListControl, {
    callbackListControlTester
} from './CallbackListControl';
import EnumCheckboxControl, {
    enumCheckboxControlTester
} from './EnumCheckboxControl';
import ArrayObjectControl, {
    arrayObjectControlTester
} from './ArrayObjectControl';
import SendSmsControl, { sendSmsControlTester } from './SendSmsControl';
import ChecklistSettingsLink, {
    checklistSettingsLinkTester
} from './ChecklistSettingsLink';
import OrderCallbackFiltersControl, {
    orderCallbackFiltersControlTester
} from './OrderCallbackFiltersControl';
import BannerControl, { bannerControlTester } from './BannerControl';
import BusinessUnitControl, {
    businessUnitControlTester
} from './BusinessUnitControl';
import EnumRadioControl, { enumRadioControlTester } from './EnumRadioControl';
import VAETeamControl, { vaeTeamControlTester } from './VAETeamControl';
import DispatchWaveControl, {
    dispatchWaveControlTester
} from './DispatchWaveControl';
import AttributeSettings, {
    attributeSettingsTester
} from './AttributeSettings';
import MultiChipTextField, {
    multiChipTextFieldTester
} from './MultiChipInputControl/MultiChipTextField';
import SlotManagementControl, {
    slotManagementControlTester
} from './SlotManagementControl';

const renderers = [
    { renderer: EnumControl, tester: enumControlTester },
    { renderer: SwitchControl, tester: switchControlTester },
    { renderer: TextFieldControl, tester: textFieldControlTester },
    { renderer: ArrayTextFieldControl, tester: arrayTextFieldControlTester },
    { renderer: NumberFieldControl, tester: numberFieldControlTester },
    { renderer: ImageUploadControl, tester: imageUploadControlTester },

    { renderer: LanguageControl, tester: languageControlTester },
    { renderer: TimezoneControl, tester: timezoneControlTester },
    { renderer: CountryCodeControl, tester: countryCodeControlTester },
    { renderer: CountryDialCodeControl, tester: countryDialCodeControlTester },
    { renderer: CurrencyControl, tester: currencyControlTester },
    { renderer: NumberFormatControl, tester: numberFormatControlTester },
    {
        renderer: TimeFieldControl,
        tester: timeFieldControlTester
    },
    { renderer: ArrayObjectControl, tester: arrayObjectControlTester },
    { renderer: EnumCheckboxControl, tester: enumCheckboxControlTester },
    { renderer: SlotManagementControl, tester: slotManagementControlTester },
    {
        renderer: ArrayStringInputControl,
        tester: arrayStringInputControlTester
    },
    {
        renderer: ArrayObjectInputControl,
        tester: arrayObjectInputControlTester
    },
    {
        renderer: CallbackListControl,
        tester: callbackListControlTester
    },
    { renderer: SendSmsControl, tester: sendSmsControlTester },
    { renderer: ChecklistSettingsLink, tester: checklistSettingsLinkTester },
    {
        renderer: OrderCallbackFiltersControl,
        tester: orderCallbackFiltersControlTester
    },
    { renderer: BannerControl, tester: bannerControlTester },
    { renderer: EnumRadioControl, tester: enumRadioControlTester },
    { renderer: BusinessUnitControl, tester: businessUnitControlTester },
    { renderer: AttributeSettings, tester: attributeSettingsTester },
    { renderer: VAETeamControl, tester: vaeTeamControlTester },
    { renderer: DispatchWaveControl, tester: dispatchWaveControlTester },
    { renderer: MultiChipTextField, tester: multiChipTextFieldTester }
];

// FieldWrapper helps us highlighting the content with a border based on setting query param.
const wrappedRenderers: $FixMe = renderers.map(
    ({ renderer: Control, tester }) => ({
        renderer: (props: $FixMe) => (
            <FieldWrapper {...props}>
                <Control {...props} />
            </FieldWrapper>
        ),
        tester
    })
);

export default wrappedRenderers;
